import { AlbaranApiService } from "../../../../service/api/albaran-api.service";
import { createCsv, createCsvField } from '@fitogest/reactive-form-builder/csv';
import { InputType, FormField, FormType } from '@fitogest/reactive-form-builder/interfaces';
import { environment } from "../../../../../environments/environment";
import {
    Component,
    ViewChild,
    ElementRef,
    OnDestroy,
    OnInit,
    AfterViewInit,
} from '@angular/core';
import { Router } from "@angular/router";
import { DashboardService } from "../../../../service/events/dashboard.service";
import { RequestHandler } from "../../../../service/OffService/request-handler";
import { RequestButtonTypes } from "../../../../common/components/request-button/request-button.component";
import { Filtering } from "../../../../service/filtering/filtering";
import { Utils } from "../../../../common/utils";
import { BaseView } from "../../../base-view";
import { renderHtml2Canvas } from 'src/app/common/html2-canvas-renderer';
import { StorageManager } from "../../../../common/storage-manager.class";
import moment from "moment";
// import { MessageService } from 'primeng/api';

import { AlbaranModel } from "src/app/models/ventas/albaran.model";
import { ColInterface } from "src/app/common/components/common-list-table/col.interface";
import { ColStylesInterface } from "src/app/common/components/common-list-table/col-styles.interface";

import { AlbaranesListModalFormDefinition } from './albaranes-form/form-control/list-modal-form-definition';
import { createJsPdf } from 'src/app/common/pdf-document-renderer';
@Component({
  selector: "app-albaranes",
  standalone: false,
  templateUrl: "./albaranes.component.html",
  styleUrls: ["./albaranes.component.scss"],
})
export class AlbaranesComponent
  extends BaseView<AlbaranModel>
  implements OnInit, OnDestroy, AfterViewInit {
    public form: AlbaranesListModalFormDefinition | null = null;

  @ViewChild("passport", { static: true }) passport: ElementRef | undefined;

  public showBtnTratamiento = environment.features.showBtnTratamiento;
  public years = [{ label: "...", value: 0 }];
  public selectedYears = 0;

  public rolUser = StorageManager.getUser().rol;
  public hiddenButtonDelete = false;
  public appName: string = environment.appName;
  public serverUrl = environment.serverUrl;
  public logoUrl: string = environment.logoUrl;
  public showEnviarWhatsapp = environment.features.showEnviarWhatsapp;
  public showEnviarTelegram = environment.features.showEnviarTelegram;
  public showEnviarCorreo = environment.features.showEnviarCorreo;
  public showPrescripcionTratamiento =
    environment.features.showPrescripcionTratamiento;
  public showRecetaGlobalGAP = environment.features.showRecetaGlobalGAP;

  public tooltipForce = false;
  public tooltipClass = this.tooltipForce
    ? "telegram-passport-tooltip telegram-passport-tooltip-shown"
    : "telegram-passport-tooltip";

  public textoSuperficie = environment.features.textoSuperficie;

  public empresaName = environment.features.empresaName;
  public canAddAlbaranes = environment.features.canAddTareas;
  public canDuplicateAlbaranes = environment.features.canDuplicateTareas;
  public hasClients = environment.features.hasClients;
  public userCanSeeClientes =
    this.hasClients &&
    (environment.features.userCanSeeClientes
      ? true
      : StorageManager.getUser().rol === "admin");
  public rol = StorageManager.getUser().rol;

  public isGeneratingCanvas: boolean = false;
  public showEnviando = false;

  public getRequest: RequestHandler<AlbaranModel[]> = this.albaranesApi.albaranesGET;
  public deleteRequest: RequestHandler<AlbaranModel[]> = this.albaranesApi.albaranesDELETE;
  public pathToForm = "crear-albaran";
  public menuItemId = "albaranes";

  public deleteRequestButtonType: RequestButtonTypes =
    RequestButtonTypes.DELETE;

  public override canShow: { [key: string]: any } = {};
  public override model: any = {};

  public showReceta = false;
  public isShowingGlobalGAP = false;
  public receta: any;
  public currentUser = StorageManager.getUser();
  public observaciones = "";
  public empresa = "Locatec Aplicaciones Informáticas";

  public override filtering: Filtering<any> = new Filtering<any>();
  public currentYear: string = "";

  public btnAnadir = "Añadir Albarán";

  public distributionOrder = [4];

  public imageLoaded = false;

  public nameReceta: string =
    environment.features.showRecetaPascualCabedo &&
      this.appName !== "gruesnadal"
      ? "Parte de trabajo"
      : "Generar Albarán";

  public sm = localStorage.getItem("sm") ? true : false;

  public albaranInfo: FormField<any>[] = [
    createCsvField<any>('albaran_id', 'id'),

    createCsvField<any>('chofer_nombre', 'chofer'),
    createCsvField<any>('fecha', 'fecha'),
    createCsvField<any>('direccion', 'direccion'),
    createCsvField<any>('cif', 'cif'),
    createCsvField<any>('cliente_nombre', 'cliente'),
    createCsvField<any>('poblacion', 'poblacion'),
    createCsvField<any>('cp', 'cp'),
    createCsvField<any>('telefono', 'telefono'),
    createCsvField<any>('correo', 'correo'),
    createCsvField<any>('obra_nombre', 'obra'),
  ];

  public albaranMaterialesInfo: FormField<any>[] = this.autoFill();
  private autoFill() {
    const tempArray: FormField<any>[] = [];
    for (let i = 1; i <= 4; i++) {
      tempArray.push(
        createCsvField<any>(`cantidad${i}`, `cantidad${i}`),
        createCsvField<any>(`maquinaria_nombre_${i}`, `concepto${i}`),
        createCsvField<any>(`precio${i}`, `precio${i}`),
        createCsvField<any>(`total${i}`, `total${i}`)
      );
    }

    return tempArray;
  }

  public datosAdicionales: FormField<any>[] = [
    createCsvField<any>('trabajos_realizados', 'trabajos_realizados', InputType.TEXTAREA),

    createCsvField<any>('conforme', 'conforme', InputType.TEXTAREA),
  ];

  public totalHoras: any = "00:00";
  public auxTotalHoras: any = "00:00";

  public cols = [
    //{ field: 'referencia_receta', header: 'Orden', filter: '', width: '60px', visible: this.appName === 'pyf' },
    {
      field: "albaran_id",
      header: "Nº\xa0Referencia",
      filter: "",
      width: "160px",
      visible: this.appName !== "pyf" && this.appName !== "donjardin",
    },
    {
      field: "chofer_nombre",
      header: "Chofer",
      filter: "",
      width: "160px",
      visible: this.appName !== "pyf" && this.appName !== "donjardin",
    },
    {
      field: "fecha",
      header: "Fecha",
      filter: "",
      width: "160px",
      visible: this.appName !== "pyf" && this.appName !== "donjardin",
    },
    {
      field: "cliente_nombre",
      header: "Cliente",
      filter: "",
      width: "160px",
      visible: this.appName !== "pyf" && this.appName !== "donjardin",
    },
    {
      field: "poblacion",
      header: "Poblacion",
      filter: "",
      width: "160px",
      visible: this.appName !== "pyf" && this.appName !== "donjardin",
    },
    {
      field: "obra_nombre",
      header: "Obra",
      filter: "",
      width: "160px",
      visible: this.appName !== "pyf" && this.appName !== "donjardin",
    },
    {
      field: "contabilizado",
      header: "Contabilizado",
      filter: "",
      width: "160px",
      visible: this.appName !== "pyf" && this.appName !== "donjardin",
    },
    {
      field: "enviado",
      header: "Enviado",
      filter: "",
      width: "160px",
      visible: this.appName !== "pyf" && this.appName !== "donjardin",
    },

  ];
  public str: string = "";

  constructor(
    public albaranesApi: AlbaranApiService,
    private dashboard: DashboardService,
    private router: Router // private messageService: MessageService
  ) {
    super(dashboard, albaranesApi.albaranesGET);
  }

  ngAfterViewInit(): void {
    // throw new Error("Method not implemented.");
    console.log('Starting Module...');

  }

  ngOnInit() {
    if (environment.features.showTareasMto) {
      if (this.rolUser !== "admin") {
        this.hiddenButtonDelete = true;
      }
    }

    this.dashboard.setSubmenuItem('ventas', this.menuItemId);

    this.expandFormFields();

    this.appName = environment.appName;

    if (this.empresaName !== "") {
      this.empresa = this.empresaName;
    }

    if (this.appName === "melia") {
      this.empresa = this.currentUser.apellidos;
    }

    this.dashboard.setHeaderTitle("Albaranes");
  }

  decode(utftext: string) {
    let string = "",
      i = 0,
      c = 0,
      c2 = 0,
      c3 = 0;

    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);
        // eslint-disable-next-line no-bitwise
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        // eslint-disable-next-line no-bitwise
        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        i += 3;
      }
    }

    return string;
  }

  selectedCampaign() {
    this.filtering.filter();
  }

  compareDates(row: any) {
    const auxFecha = (row["fecha_inicio"] as string).split("/");
    const nuevaFecha = moment(
      auxFecha[2] + "-" + auxFecha[1] + "-" + auxFecha[0]
    );
    const fechaComparar = moment(
      "20" + this.selectedYears.toString() + "-07" + "-01"
    );
    const fechaMax = moment(
      "20" + (this.selectedYears + 1).toString() + "-06" + "-30"
    );

    if (nuevaFecha > fechaComparar && nuevaFecha < fechaMax) {
      return true;
    } else {
      return false;
    }
  }

  public add() {
    this.router.navigate(["dashboard", this.pathToForm]);
  }

  public edit(data: any) {
    this.router.navigate(["dashboard", "editar-albaran", data.data.id]);
  }

  public duplicate(data: any) {
    this.router.navigate(["dashboard", "duplicar-albaran", data.data.id]);
  }

  public override deleteRegister() {
    if (this.model["id"]) {
      this.deleteRequest.safePerform(this.model);
      this.deleteRequest.response(() => {
        if (!this.deleteRequest.hasError) {
          this.getRequest.safePerform();
        }
      });
    } else {
      this.deleteRequest.hasError = true;
      throw new Error("Trying to DELETE a register without primary key");
    }
  }

  public override show(modal: string, data: any) {
    super.show(modal, data.data)
        this.setModalForm(modal);
  }

  public override hide(modal: string) {
    this.model = null;
    this.canShow[modal] = false;
    this.deleteRequest.reset();
  }

  public override ngOnDestroy() {
    Utils.unsuscribe([
      this.albaranesApi.albaranesGET,
      this.albaranesApi.albaranesDELETE,
    ]);
  }

  public enviarCorreo(email: string | null) {
    this.showEnviando = true;
    this.isGeneratingCanvas = true;
    const config = this.getPrintConfig();

    renderHtml2Canvas(
      document.getElementById('html2canvasDiv') ?? new HTMLElement(),
      { scale: config.canvasScale, logging: false, useCORS: true }
    ).then(async canvas => {
      this.isGeneratingCanvas = false;
      const pdf = await createJsPdf(config.orientation, 'mm', 'a4');
      const data = canvas.toDataURL('image/png');

      if (canvas.width > canvas.height) {
        pdf.addImage(data, 'png', 0, 0, config.width, (canvas.height / (canvas.width / config.width)), 'alias', 'FAST');
      } else {
        pdf.addImage(data, 'png', 0, 0, (canvas.width / (canvas.height / config.height)), config.height, 'alias', 'FAST');
      }

      const adjunto = encodeURIComponent(window.btoa(pdf.output()));

      console.log(adjunto)
      if (email !== '') {
        this.albaranesApi.enviarRecetaCaptura.perform({
          email,
          generado: adjunto,
          albaran: this.receta?.albaran_id
        } as never);

      } else {
        /*
        this.tareasApi.enviarRecetaCaptura.hasError = true;
        this.tareasApi.enviarRecetaCaptura['error'] = 'El cliente o finca no tiene un email asociado';
        */
      }
      return;
    }).catch(e => {
      console.log('catch en getPosition: ' + e);
    }
    ).then(() => {
      //alert('Ha habido un error al enviar el email. Si este error persiste, por favor, contacte con un administrador.');
      // console.log(error);
      setTimeout(() => {
        this.showEnviando = false;
        this.isGeneratingCanvas = false;
      }, 100);
      return;
    }).catch(e => {
      console.log('catch en getPosition: ' + e);
    }
    );
  }

  public enviarWhatsapp() {
    window.open("https://web.whatsapp.com/", "_blank");

    const config = this.getPrintConfig();

    renderHtml2Canvas(
      document.getElementById("html2canvasDiv") ?? new HTMLElement(),
      { scale: config.canvasScale, logging: false }
    ).then(async (canvas) => {
      this.isGeneratingCanvas = false;

      const pdf = await createJsPdf(config.orientation, "mm", "a4");
      const data = canvas.toDataURL("image/png");

      if (canvas.width > canvas.height) {
        if (this.appName === "pyf") {
          pdf.addImage(data, "png", 0, 20, 200, 140, "alias", undefined);
        } else {
          pdf.addImage(
            data,
            "png",
            0,
            0,
            config.width,
            canvas.height / (canvas.width / config.width),
            "alias",
            "FAST"
          );
        }
      } else {
        if (this.appName === "pyf") {
          pdf.addImage(data, "png", 0, 20, 200, 140, "alias", undefined);
        } else {
          pdf.addImage(
            data,
            "png",
            0,
            0,
            canvas.width / (canvas.height / config.height),
            config.height,
            "alias",
            "FAST"
          );
        }
      }

      const file = pdf.output("blob");

      const formData = new FormData();
      formData.append("document", file, "receta.pdf");
      formData.append("phoneNumber", "+34" + this.receta.cliente_telefono);

      function sendDocument() {
        const url = `${environment.serverUrl}ws/tareas/enviar_receta_whatsapp.php`;

        const xht = new XMLHttpRequest();

        xht.open("POST", url);
        xht.send(formData);
      }

      sendDocument();
    });

    this.showReceta = false;
  }

  public generarReceta(data: any, showAfter = true) {
    this.receta = data.data;

    this.currentYear = new Date().getFullYear().toString();
    this.receta.fecha_completa = moment(
      this.receta.fecha_fin,
      "DD/MM/YYYY"
    ).isValid()
      ? moment(this.receta.fecha_fin, "DD/MM/YYYY").format("LL")
      : "___/___/______";

    if (showAfter) {
      this.showReceta = true;
    }
  }

  public generarGlobalGAP(data: any) {
    this.generarReceta(data, false);

    this.isShowingGlobalGAP = true;
  }

  public getPrintConfig() {
    const config: {
      canvasScale: number;
      orientation: "p" | "l";
      width: number;
      height: number;
    } = {
      canvasScale: 2,
      orientation: "p",
      width: 210,
      height: 290,
    };

    switch (this.appName) {
      case "laplana":
        config.canvasScale = 1.04;
        config.width = 197;
        config.height = 290;
        break;
      case "pascualcabedo":
        config.canvasScale = 0.86;
        break;
      case "vginer":
        config.orientation = "l";
        config.width = 290;
        config.height = 210;
        break;
      case "esparragosgranada":
        config.orientation = "l";
        config.width = 290;
        config.height = 187;
        break;
      case "fitogest":
        config.orientation = "l";
        config.width = 290;
        config.height = 210;
        break;
      case "agrogest":
        config.orientation = "l";
        config.width = 290;
        config.height = 210;
        break;
      case "armentia":
        config.orientation = "l";
        config.width = 290;
        config.height = 210;
        break;
      case "melia":
        config.width = 320;
        config.height = 250;
        break;
      case "saviatropical":
        config.orientation = "l";
        config.width = 290;
        config.height = 210;
        break;
      case "gragon":
        config.orientation = "l";
        config.width = 290;
        config.height = 210;
        break;
      default:
        break;
    }
    return config;
  }

  public imprimirReceta() {
    this.isGeneratingCanvas = true;
    const config = this.getPrintConfig();
    renderHtml2Canvas(
      document.getElementById("html2canvasDiv") ?? new HTMLElement(),
      { scale: config.canvasScale, logging: false, useCORS: true }
    ).then(async (canvas) => {
      this.isGeneratingCanvas = false;

      const pdf = await createJsPdf(config.orientation, "mm", "a4");
      const data = canvas.toDataURL("image/png");

      const padding = 10; // Padding de 10mm solo en horizontal

      // Ajusta el ancho disponible para la imagen restando el padding horizontal
      let imgWidth = config.width - padding * 2;
      let imgHeight = canvas.height / (canvas.width / imgWidth); // Mantiene la proporción de la imagen

      // Cálculo para centrar la imagen solo horizontalmente con padding
      const xOffset = (config.width - imgWidth) / 2; // Desplazamiento horizontal con padding
      const yOffset = 0; // No se aplica ningún desplazamiento vertical (sin padding vertical)

      if (canvas.width > canvas.height) {
        if (this.appName === "pyf") {
          pdf.addImage(
            data,
            "png",
            xOffset,
            yOffset + 20,
            imgWidth,
            140,
            "alias",
            undefined
          );
        } else {
          pdf.addImage(
            data,
            "png",
            xOffset, // Coordenada X centrada con padding horizontal
            yOffset, // Coordenada Y sin padding
            imgWidth,
            imgHeight,
            "alias",
            "FAST"
          );
        }
      } else {
        if (this.appName === "pyf") {
          pdf.addImage(
            data,
            "png",
            xOffset,
            yOffset + 20,
            imgWidth,
            140,
            "alias",
            undefined
          );
        } else {
          pdf.addImage(
            data,
            "png",
            xOffset, // Coordenada X centrada con padding horizontal
            yOffset, // Coordenada Y sin padding
            imgWidth,
            imgHeight,
            "alias",
            "FAST"
          );
        }
      }

      pdf.save(`albarán-${this.receta["id"]}`);
    });
  }

  public enviarTelegram() {
    const idTelegram = StorageManager.getUser().id_telegram;

    if (!idTelegram) {
      const elementPassport = this.passport?.nativeElement;

      const passport = document.createElement("script");
      const key = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA72n4YZpEZfgholYLVavB
mtDw3uLgHHxg6Ed6HdNipVPt8pvI+PqFlBlg3Bkpkz+Mxh5GOLy45aF/5AIqk/6A
qk1C5h9j7kgKyAWVlGDvkDiF+CBSrTTdw3CJRog+d1Vm6bvGk7SsUK//aO79u5Fc
9hsidWP0C4ngkK2lOX0+xK/DreZqlSYjt0BecYTV+ldI+Bys5D1TI6365N1SniHB
DjHddB/7DCreFB+MD+ZMcMDq6H59B2kNmI8TI7SHKk3q6x60HajsHXnQBuqm2y5E
TuC1fnwt9yxpLXOTHXxGL0fTuqlv847pLvpBCsZvpug4Zckn/N14hbho9JTbYwD0
fwIDAQAB
-----END PUBLIC KEY-----`;

      const authButton = document.getElementById("telegram_passport_auth");
      passport.text =
        `var auth_button = document.getElementById('telegram_passport_auth');
            var auth_params = {
              bot_id:        6449999161,
              scope:         {data: [{type: 'id_document', selfie: true}, 'address_document', 'phone_number', 'email'], v: 1},
              public_key:    ` +
        "`" +
        key +
        "`" +
        `,
              nonce:         '${environment.serverUrl}',
              callback_url:  '${environment.serverUrl}#/dashboard/fitosanitarios'
            };
            auth_button.addEventListener('click', function() {
                Telegram.Passport.auth(auth_params, function(show) {
                    if (show) {

                    } else {

                    }
                });
            }
            , false);`;

      elementPassport.parentElement.replaceChild(passport, elementPassport);

      authButton?.click();
      this.tooltipForce = true;
      this.tooltipClass = this.tooltipForce
        ? "telegram-passport-tooltip telegram-passport-tooltip-shown"
        : "telegram-passport-tooltip";
    } else {
      this.isGeneratingCanvas = true;
      const config = this.getPrintConfig();

      renderHtml2Canvas(
        document.getElementById("html2canvasDiv") ?? new HTMLElement(),
        { scale: config.canvasScale, logging: false }
      ).then(async (canvas) => {
        this.isGeneratingCanvas = false;

        const pdf = await createJsPdf(config.orientation, "mm", "a4");
        const data = canvas.toDataURL("image/png");

        if (canvas.width > canvas.height) {
          if (this.appName === "pyf") {
            pdf.addImage(data, "png", 0, 20, 200, 140, "alias", undefined);
          } else {
            pdf.addImage(
              data,
              "png",
              0,
              0,
              config.width,
              canvas.height / (canvas.width / config.width),
              "alias",
              "FAST"
            );
          }
        } else {
          if (this.appName === "pyf") {
            pdf.addImage(data, "png", 0, 20, 200, 140, "alias", undefined);
          } else {
            pdf.addImage(
              data,
              "png",
              0,
              0,
              canvas.width / (canvas.height / config.height),
              config.height,
              "alias",
              "FAST"
            );
          }
        }

        const blob = pdf.output("blob");
        const file = new File([blob], "receta.pdf");

        const tg = {
          token: "6449999161:AAFpVGCLY2bF4NAOs98mU4Brw7KVI9hZRBY",
          chat_id: StorageManager.getUser().id_telegram,
        };

        const formData = new FormData();
        formData.append("document", file, "receta.pdf");

        function sendDocument() {
          const url = `https://api.telegram.org/bot${tg.token}/sendDocument?chat_id=${tg.chat_id}`;
          const xht = new XMLHttpRequest();

          xht.open("POST", url);
          xht.send(formData);
        }

        sendDocument();
      });
    }
  }

  public globalConditionalStyle(
    _value: string, col: ColInterface
  ): ColStylesInterface {
    let estiloVademecum: any = {};

    if (col.field === "trabajadores_nombres") {
      return {
        style: {
          "max-width": "50px",
        },
      };
    }
    if (col.field === "observaciones") {
      return {
        style: {
          "max-width": "50px",
        },
      };
    }

    if (col.field === "contabilizado" || col.field === "enviado") {
      let color
      if (_value === '1' || _value === '✓') {
        color = 'green';
      }
      else {
        color = 'red';
      }
      return {
        style: {
          "max-width": "50px",
          "text-align": "center",
          "color": color,
        },
      };
    }


    if (environment.features.showTareasMto) {
      if (col.field === "aplicado") {
        if (_value === "0") {
          return {
            rowStyle: {
              backgroundColor: "#f44242",
            },
          };
        } else if (_value === "1") {
          return {
            rowStyle: {
              backgroundColor: "#00ff00",
            },
          };
        }
      }
    }

    // if (Utils.isNumber(value) && col.field !== 'sector' && col.field !== 'facturado') {
    if (col.field !== "sector" && col.field !== "facturado") {
      if (col.field === "id" || col.field === "horas_totales") {
        return { textAlign: "center" };
      } else {
        return { textAlign: "right", paddingRight: "40px" };
      }
    }

    if (["id", "fecha_inicio", "fecha_fin"].includes(col.field)) {
      return { textAlign: "center" };
    }

    return estiloVademecum;
  }

  public globalVisualTransform(
    value: string,
    col: ColInterface
  ) {

    if (col.field === 'contabilizado' || col.field === "enviado") {
      value = value === '1' ? '✓' : '✕';
    }

    return value;
  }

  public formatDate(date: string) {
    moment.locale("es");
    return moment(date, "DD/MM/YYYY").format("LL");
  }

  public createNavigation(route: string) {
    this.router.navigate(["dashboard", route]);
  }

  public async downloadCsv() {
    const arrayFormFields = [
      this.albaranInfo,
      this.albaranMaterialesInfo,
      this.albaranMaterialesInfo,
    ];
    const csvFields = arrayFormFields
      .flat()
      .filter((field) => field.conditions.isVisible && field.input.type !== InputType.EMPTY);

    const csvContent = createCsv(
      csvFields,
      csvFields.map((field) => field.label),
      this.filtering.value as any[]
    );

    const csvLink: any = document.getElementById("csvLink");
    csvLink.download = "Fitosanitarios.csv";
    csvLink.href = encodeURI(csvContent);
    csvLink.click();
  }

  private expandFormFields() { }

  public static createNavigation(router: Router, route: string = "albaranes") {
    router.navigate(["dashboard", route]);
  }
    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new AlbaranesListModalFormDefinition(formType, this.model, this);
    }

}
